import classes from "./SearchPage.module.css";

import SearchCard from "../../components/Search/SearchCard/SearchCard";

import SearchProvider from "../../store/SearchProvider";

import useWindowDimensions from "../../hooks/useWindowDimensions";

// page to search cocktails on backend with ingredients as search criteria
const SearchPage = () => {
  const { width } = useWindowDimensions();

  return (
    <SearchProvider>
      
      <div className={classes.query_page}>
        {width > 1200 && (
          <img
            className={classes.full_skeleton_left}
            src={"/assets/gen_graphics/full_skeleton_hand.png"}
            alt="new"
            style={{ right: width / 2 + 295 }}
          />
        )}
        <SearchCard/>
        {width > 1200 && (
          <img
            className={classes.full_skeleton_right}
            src={"/assets/gen_graphics/full_skeleton_hand.png"}
            alt="new"
            style={{ left: width / 2 + 295 }}
          />
        )}
      </div>
    </SearchProvider>
  );
};

export default SearchPage;
